var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_speaker@0.0x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-338.000000, -152.000000)",
    fill: "#51575C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(226.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device",
    transform: "translate(112.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_speaker",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00166664437,5.3006 L0.00166664437,10.7006 L3.55666664,10.7006 L8.00066664,15.2006 L8.00066664,0.8006 L3.55666664,5.3006 L0.00166664437,5.3006 L0.00166664437,5.3006 Z M9.60066664,0.0011 C13.3419706,0.843029199 16,4.16568366 16,8.00055 C16,11.8354163 13.3419706,15.1580708 9.60066664,16 L9.60066664,16 L9.60066664,14.1165 C12.3113735,13.3161641 14.1718477,10.826988 14.1718477,8.0006 C14.1718477,5.17421201 12.3113735,2.68503594 9.60066664,1.8847 L9.60066664,1.8847 Z M9.60066664,4.0006 C11.0859209,4.77875298 12.0120792,6.32138538 12.0006666,7.9981 C12.0108981,9.67577146 11.0853494,11.2193168 9.60066664,12.0006 L9.60066664,12.0006 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.7da993394e89eaf6e454ceaa68d946ef.svg";
export { ForwardRef as ReactComponent };